import React from 'react'

const logos = [
  { name: 'Company 1', src: '/company/c-logo1.svg' },
  { name: 'Company 2', src: '/company/c-logo2.png' },
  { name: 'Company 3', src: '/company/c-logo3.svg' },
  { name: 'Company 4', src: '/company/c-logo4.png' },
]

const Press = () => {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-24 xl:px-28 py-8 sm:py-10 lg:py-12">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-6">
        <p className="font-mono text-[12px] sm:text-[13px] lg:text-[14px] uppercase tracking-[0.28px] text-[#1c2329] leading-[1.5] text-center">
          1000+ Businesses Trust Us
        </p>
        <div className="flex w-full flex-wrap items-center justify-center gap-x-8 sm:gap-x-12 md:gap-x-16 lg:gap-x-20 xl:gap-x-24 gap-y-6 sm:gap-y-8">
          {logos.map((logo, index) => {
            // 3rd logo (index 2) keeps the larger size, others are smaller
            const sizeClass = index === 2 
              ? "h-8 sm:h-10 md:h-12 lg:h-14" 
              : "h-6 sm:h-7 md:h-9 lg:h-11"
            
            return (
              <img
                key={logo.name}
                src={logo.src}
                alt={logo.name}
                className={`${sizeClass} w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100`}
                loading="lazy"
              />
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Press

